import { useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { useMachineStore } from 'Store/Machine'
import { useAppStore } from 'Store/App'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { PileExecutedStatusChangerContext } from '../PileExecutedStatusChanger/Context'

const ViewModel = () => {
  const navigate = useNavigate()
  const { id: projectId } = useParams<{ id: string }>()
  const { data, projectMachines, getData, getMachines, clearState } = useProjectStore(
    state => ({
      data: state.pileHoles,
      projectData: state.selected,
      projectMachines: state.machines,
      getData: state.getPileHoles,
      getMachines: state.getAllProjectMachine,
      clearState: state.clearState,
    }),
    shallow
  )
  const { machineData, getMachineData } = useMachineStore(
    state => ({
      machineData: state.data,
      getMachineData: state.getAll,
    }),
    shallow
  )
  const { setOpen, setCurrentPileHoleId } = useContext(PileExecutedStatusChangerContext)
  const setShowBackButton = useAppStore(state => state.setShowBackButton, shallow)

  const projectMachineOptions = projectMachines.map(pm => {
    const machine = machineData.find(m => m.id === pm.machineId)
    return {
      label: `${machine?.brand ?? ''} ${machine?.machineModel ?? ''} (${machine?.machineCode}) - ${
        machine?.machineType?.title
      }`,
      value: pm.id,
    }
  })

  const fetchData = () => {
    if (projectId) {
      getMachineData()
      getMachines(projectId)
      getData(parseInt(projectId)).then(({ success, data }) => {
        if (!success) {
          toast.error(`Fetch data failed : ${data}`)
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        text: 'Project ID is not found',
      }).then(() => {
        navigate('/project')
      })
    }
  }

  const onScan = (pileHoleId: number) => {
    navigate(`/project/${projectId}/pile-execution?pileHoleId=${pileHoleId}`)
  }

  const onPrint = (pileHoleId: number) => {
    window.open(`/project/${projectId}/pile-executed-list/${pileHoleId}/print`, '_blank')
  }

  const onChangeStatus = (pileHoleId: string) => {
    setCurrentPileHoleId(pileHoleId)
    setOpen(true)
  }

  useEffect(() => {
    fetchData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  useEffect(() => {
    setShowBackButton(true)

    return () => {
      clearState()
      setShowBackButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    projectMachineOptions,
    data,
    projectId,
    onScan,
    onChangeStatus,
    onPrint,
  }
}

export default ViewModel
